module.exports = __webpack_public_path__ + "static/New_Hero_Regular-94ec494e9e679fd505c57aa579deb4b0.otf";